import React from 'react'
import clsx from 'clsx'
import dayjs from 'dayjs'
import { makeStyles, createStyles, Typography } from '@material-ui/core'
import CMSText from '../Global/CMSText'
import Price from '../Shop/Price'
import { useTakeback } from '../../hooks/useTakeback'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing(3),
    },
    takeBackListTitle: {
      marginBottom: theme.spacing(2),
    },
    takeBackListHeader: {
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center',
    },
    takeBackItemTitle: {
      paddingLeft: theme.spacing(1),
    },
    circle: {
      width: 16,
      height: 16,
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.main,
    },
    productCard: {
      background: theme.palette.common.white,
      borderRadius: theme.shape.borderRadius,
      minHeight: 60,
      padding: theme.spacing(1),
      display: 'flex',
      justifyContent: '',
      alignItems: 'center',
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
    },
    takeBackItem: {
      borderLeft: `1px solid currentColor`,
      paddingLeft: theme.spacing(2),
      marginLeft: theme.spacing(1),
      paddingBottom: theme.spacing(3),
    },
    takeBackItemLast: {
      borderLeft: 0,
    },
    imgProduct: {
      width: 50,
      height: 50,
      objectFit: 'contain',
      display: 'block',
    },
    imgContainer: {
      width: 50,
      marginLeft: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        marginLeft: theme.spacing(0),
      },
    },
    productName: {
      marginLeft: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        marginLeft: theme.spacing(1),
      },
    },
    productPrice: {
      marginLeft: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        marginLeft: theme.spacing(1),
      },
    },
    productStatus: {
      marginLeft: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        marginLeft: theme.spacing(1),
      },
    },
  })
)

type Tprops = {
  t: any
  takeback: any
  userTakeBackProducts: any
  settings: any
}

const TakeBackList = ({
  t,
  takeback,
  userTakeBackProducts,
  settings,
}: Tprops) => {
  const classes = useStyles()
  const { productCheckState, productCheckStatus } = useTakeback()
  const states = productCheckState(takeback?.data)
  const status = productCheckStatus(takeback?.data)

  return (
    <div className={classes.root}>
      <Typography
        variant={'h5'}
        component={'h2'}
        className={classes.takeBackListTitle}
      >
        <CMSText
          asText
          data={takeback?.data?.take_back_list_title}
          defaultText={t('texts:account:take_back_list_title')}
        />
      </Typography>
      {userTakeBackProducts?.response?.length > 0 &&
        userTakeBackProducts?.response.map((takeBackProducts, index) => {
          const takeBackDate = dayjs(takeBackProducts.date).format('L')
          const lastTakeBackProducts =
            index + 1 === userTakeBackProducts?.response.length
          return (
            <div key={index}>
              <div className={classes.takeBackListHeader}>
                <div className={classes.circle}></div>
                <Typography
                  variant={'body1'}
                  color={'primary'}
                  className={classes.takeBackItemTitle}
                >
                  <CMSText
                    asText
                    data={takeback?.data?.command}
                    defaultText={t('texts:takeBack:command')}
                  />
                  {takeBackProducts.id}
                </Typography>
              </div>

              <div
                className={clsx(
                  classes.takeBackItem,
                  lastTakeBackProducts && classes.takeBackItemLast
                )}
              >
                <Typography variant={'body2'} color={'textSecondary'}>
                  {takeBackDate}
                </Typography>
                {takeBackProducts.products.map((item, index) => {
                  return (
                    <div key={index}>
                      <div className={classes.productCard}>
                        <div className={classes.imgContainer}>
                          {item.image === null ? (
                            <img
                              src={
                                settings?.default_image?.url
                                  ? settings?.default_image?.url
                                  : '/images/placeholder.jpg'
                              }
                              alt={''}
                              className={classes.imgProduct}
                              width={50}
                              height={50}
                            />
                          ) : (
                            <img
                              src={item.image}
                              alt={''}
                              className={classes.imgProduct}
                              width={50}
                              height={50}
                            />
                          )}
                        </div>
                        <div>
                          <div className={classes.productName}>
                            {item.name}
                            <>&nbsp;-&nbsp;</>
                            {item.size}
                            <>&nbsp;-&nbsp;</>
                            {states[`${item.quality}`].title}
                          </div>
                          <div className={classes.productPrice}>
                            <CMSText
                              asText
                              data={takeback?.data?.take_back_estimated_price}
                              defaultText={t(
                                'texts:takeBack:take_back_estimated_price'
                              )}
                            />
                            &nbsp;
                            <Price amount={item.price} />
                          </div>
                          <div className={classes.productStatus}>
                            <CMSText
                              asText
                              data={takeback?.data?.status_label}
                              defaultText={t('texts:takeBack:status_label')}
                            />
                            &nbsp;<b>{status[`${item.status}`]}</b>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          )
        })}
    </div>
  )
}

export default TakeBackList
